// src/pages/About/OurService.jsx
import React from 'react';
import Header from '../../components/common/Header/Header';
import Footer from '../../components/common/Footer/Footer';
import Layout from '../../components/common/Layout/Layout';

const AwardGalleyPage = () => {
    const styles = {
        pageContainer: {
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: '#ffffff'
        },
        // Coming Soon Section Styles
        comingSoonSection: {
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#f8f9fa',
            padding: '4rem 2rem',
            minHeight: '60vh'
        },
        comingSoonContainer: {
            textAlign: 'center',
            maxWidth: '600px',
            margin: '0 auto'
        },
        comingSoonTitle: {
            fontSize: '3.5rem',
            fontWeight: '700',
            color: '#1a1a1a',
            marginBottom: '1rem',
            lineHeight: '1.2'
        },
        comingSoonSubtitle: {
            fontSize: '1.5rem',
            color: '#6b7280',
            marginBottom: '2rem',
            lineHeight: '1.4'
        },
        comingSoonDescription: {
            fontSize: '1.1rem',
            color: '#4b5563',
            lineHeight: '1.6',
            marginBottom: '2rem'
        },
        comingSoonIcon: {
            fontSize: '4rem',
            marginBottom: '2rem',
            color: '#22c55e'
        },
        notifyButton: {
            backgroundColor: '#22c55e',
            color: 'white',
            padding: '0.75rem 2rem',
            border: 'none',
            borderRadius: '8px',
            fontSize: '1rem',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'background-color 0.3s ease',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.5rem'
        }
    };

    return (
        <>
            <style>{`
                .notify-button:hover {
                    background-color: #16a34a;
                }
                
                @media (max-width: 768px) {
                    .coming-soon-title {
                        font-size: 2.5rem !important;
                    }
                    
                    .coming-soon-subtitle {
                        font-size: 1.2rem !important;
                    }
                    
                    .coming-soon-description {
                        font-size: 1rem !important;
                    }
                    
                    .coming-soon-icon {
                        font-size: 3rem !important;
                    }
                }
                
                @media (max-width: 640px) {
                    .coming-soon-section {
                        padding: 2rem 1rem;
                    }
                    
                    .coming-soon-title {
                        font-size: 2rem !important;
                    }
                    
                    .coming-soon-subtitle {
                        font-size: 1.1rem !important;
                    }
                }
            `}</style>

            <div style={styles.pageContainer}>
                {/* Header */}
                <Header />

                {/* Coming Soon Section */}
                <section style={styles.comingSoonSection} className="coming-soon-section">
                    <div style={styles.comingSoonContainer}>
                        <div style={styles.comingSoonIcon}>🚀</div>
                        <h1 style={styles.comingSoonTitle} className="coming-soon-title">
                            Coming Soon
                        </h1>
                        <h2 style={styles.comingSoonSubtitle} className="coming-soon-subtitle">
                           Award gallery
                        </h2>
                        <p style={styles.comingSoonDescription} className="coming-soon-description">
                            We're working hard to bring you an amazing experience with our investment plans. 
                            Stay tuned for exciting updates and opportunities to grow your wealth with WinNest.
                        </p>
                        <button
                            style={styles.notifyButton}
                            className="notify-button"
                            onClick={() => alert('Thank you for your interest! We\'ll notify you when this page is ready.')}
                        >
                            Notify Me When Ready →
                        </button>
                    </div>
                </section>

                {/* Layout */}
                <Layout />

                {/* Footer */}
                <Footer />
            </div>
        </>
    );
};

export default AwardGalleyPage;